import { memo } from 'react'
import { isProduction } from '../../config'
import { Stack, styled } from '@mui/material'
import { SwitchMock } from './SwitchMock'
import { WsConnection } from './WsConnection'
import { TinyButton } from './styles'
import { SessionControl } from './Session'

const Wrap = styled(Stack)`
  flex-direction: row;
  gap: 8px;
  align-items: center;
  color: ${({ theme }) => theme.color.text100};
`

export const DevTools = memo(() => {
  if (isProduction) return null

  return (
    <Wrap>
      <TinyButton>Building with {process.env.REACT_APP_ENV}</TinyButton>
      <SwitchMock />
      <WsConnection />
      <SessionControl />
    </Wrap>
  )
})
